import { defaultFiltersValue } from 'Components/collaboration/milestone/Filters'
import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Badge, Container } from 'reactstrap'
import { fetchCollaborationTasksSummaryThunk } from 'slices/collaborations/thunk'
import { AppDispatch, RootState } from 'store'
import { encodeBase64 } from 'utils/helpers'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import Skeleton from 'react-loading-skeleton'
import { Navigation, Autoplay } from "swiper/modules";

const OverallTaskSummary = () => {

    const dispatch: AppDispatch = useDispatch();
    const { data: summary, loading } = useSelector((state: RootState) => state.collaborations.summary);

    const fetchTaskSummary = async (force: boolean = false) => {
        dispatch(fetchCollaborationTasksSummaryThunk({ force }))
    }

    useEffect(() => {
        fetchTaskSummary();
    }, [])

    const totalPendingTasks = useMemo(() => {
        return Object.values(summary.steps ?? {}).reduce((acc, item) => acc + item.count, 0)
    }, [summary])

    const getFiltersQuery = (data: any) => {
        const encodedData = encodeBase64({ ...defaultFiltersValue, ...data });
        return `?filters=${encodedData}`;
    }


    if (!totalPendingTasks && !loading) return null;

    return (
        <Container fluid className='mb-3'>
            <div className="d-flex justify-content-between gap-2 align-items-md-center flex-column flex-md-row" style={{ marginBottom: '-30px' }}>
                <div className='d-flex gap-2 align-items-center'>
                    {
                        loading ? <Skeleton height={25} width={400} /> : <><h3 className="m-0">Pending Actions</h3> <Badge color="success">{totalPendingTasks}</Badge></>
                    }
                </div>
            </div>
            <Swiper modules={[Autoplay, Navigation]}
                slidesPerView={1}
                spaceBetween={10}
                navigation={{
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                }}
                autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 24,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                    },
                }}
                // loop={true}
                className="mySwiper marketplace-swiper rounded gallery-light pt-5">
                <div className="swiper-wrapper row row-cols-xxl-7 row-cols-md-5 row-cols-2 g-0">

                    {
                        loading ? (
                            <>
                                {
                                    Array.from({ length: 4 }).map((_, i) => <SwiperSlide><Skeleton height={80} className='rounded-4' /></SwiperSlide>)
                                }
                            </>
                        ) : (
                            <>
                                <SwiperSlide>
                                    <div className="col bg-white border rounded-4">
                                        <div className="p-3">
                                            <h5 className="text-muted text-start text-uppercase fs-13">Total Pending Actions</h5>
                                            <div className="d-flex align-items-center">
                                                <div className="flex-grow-1">
                                                    <Link target='_blank' to={{ pathname: '/tasks', search: getFiltersQuery({ status: 'ongoing', assignee: 'hub' }) }}>
                                                        <h4 className="mb-0 text-primary d-flex justify-content-between align-items-center w-100"><span className="counter-value" data-target={totalPendingTasks}>
                                                            {totalPendingTasks}
                                                        </span>
                                                        </h4>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                {(Object.entries(summary?.steps ?? {})).map(([slug, step], index: number) => (
                                    <SwiperSlide key={index}>
                                        <div className="col bg-white border rounded-4" key={index}>
                                            <div className="p-3">
                                                <h5 className="text-muted text-uppercase fs-13">{step.name}</h5>
                                                <div className="d-flex align-items-center">
                                                    <div className="flex-grow-1">
                                                        <Link target='_blank' to={{ pathname: '/tasks', search: getFiltersQuery({status: 'ongoing', assignee: 'hub', gig_step: slug, gig_step_obj: {value: step, label: step.name} }) }}>
                                                            <h4 className="mb-0 text-primary d-flex justify-content-between align-items-center w-100"><span className="counter-value" data-target={step.count}>
                                                                {step.count}
                                                            </span>
                                                            </h4>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </>
                        )
                    }
                </div>

                <div className="swiper-button-next mb-2"></div>
                <div className="swiper-button-prev"></div>
            </Swiper>
        </Container>
    )
}

export default OverallTaskSummary